// Six collectible patches, drawn for Virou. Each achievement has its own
// silhouette and engraving; these are not navigation icons in a generic frame.
const ink = "#102233";
const cream = "#fff2df";
const red = "#df3c4b";
const gold = "#e9b746";

const drawings: Record<string, string> = {
  "first-hit": `
    <path d="m16 41-3 19 12-5 7 7 5-18M35 44l8 16 4-9 11 1-10-20" fill="${red}"/>
    <path d="M32 3 42 8l10 2 3 11 5 10-5 10-3 11-11 3-9 6-10-6-11-3-3-11-5-10 5-10 3-11 11-2Z" fill="${gold}" stroke="${ink}" stroke-width="2.5"/>
    <circle cx="32" cy="31" r="19" fill="${cream}" stroke="${ink}" stroke-width="1.5"/>
    <path d="m35 13-16 22h12l-3 16 17-25H33Z" fill="${red}" stroke="${ink}" stroke-width="2" stroke-linejoin="round"/>
    <path d="M14 26h5M44 38h5" stroke="${ink}" stroke-width="2"/>
  `,
  "hits-25": `
    <path d="m32 3 23 12v31L32 61 9 46V15Z" fill="${red}" stroke="${ink}" stroke-width="2.5"/>
    <path d="m32 9 17 9v24L32 53 15 42V18Z" fill="${cream}"/>
    <path d="M11 31s8-13 21-13 21 13 21 13-8 13-21 13-21-13-21-13Z" fill="${gold}" stroke="${ink}" stroke-width="2.5"/>
    <circle cx="32" cy="31" r="8" fill="${ink}"/><circle cx="34" cy="28" r="3" fill="${cream}"/>
    <path d="M32 11v6M32 45v6M7 31h8M49 31h8" stroke="${ink}" stroke-width="2"/>
  `,
  "hits-100": `
    <path d="m17 4 35 7-9 44-35-7Z" fill="${red}" stroke="${ink}" stroke-width="2.5"/>
    <path d="M20 9h35v45H20Z" fill="${gold}" stroke="${ink}" stroke-width="2.5"/>
    <path d="m8 14 39-5 7 44-39 6Z" fill="${cream}" stroke="${ink}" stroke-width="2.5"/>
    <path d="m13 24 30-4M19 50l27-4" stroke="${red}" stroke-width="2"/>
    <g transform="rotate(-8 32 34)" fill="none" stroke="${ink}" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"><path d="m17 31 4-3v14M28 29h7v13h-7ZM41 29h7v13h-7Z"/></g>
    <path d="m11 6 3-3M55 59l3 2M3 35h4" stroke="${ink}" stroke-width="2"/>
  `,
  "streak-5": `
    <path d="m15 43-7 9 11-1-1 10 10-8 8 8 2-12 11 1-5-12" fill="${red}" stroke="${ink}" stroke-width="2"/>
    <path d="M35 3c2 13 18 16 18 32a21 21 0 0 1-42 0c0-9 5-16 11-21 0 7 2 10 5 12 7-8 9-14 8-23Z" fill="${gold}" stroke="${ink}" stroke-width="2.5" stroke-linejoin="round"/>
    <path d="M34 23c1 7 8 10 8 18a10 10 0 0 1-20 0c0-4 3-9 6-12l2 8Z" fill="${red}"/>
    <path d="M9 17H3M8 26H1M57 25h6" stroke="${ink}" stroke-width="2" stroke-linecap="round"/>
    <path d="M27 47h10" stroke="${cream}" stroke-width="2"/>
  `,
  "first-victory": `
    <path d="M18 12H6v8c0 11 9 17 18 17M46 12h12v8c0 11-9 17-18 17" fill="none" stroke="${ink}" stroke-width="5"/>
    <path d="M19 13H8v7c0 8 7 13 14 14M45 13h11v7c0 8-7 13-14 14" fill="none" stroke="${gold}" stroke-width="2"/>
    <path d="M17 5h30v20c0 10-6 16-12 18v8h10v9H19v-9h10v-8c-6-2-12-8-12-18Z" fill="${gold}" stroke="${ink}" stroke-width="2.5"/>
    <path d="M23 10v15c0 6 3 10 7 12" fill="none" stroke="${cream}" stroke-width="3"/>
    <path d="m32 15 3 6 7 1-5 5 1 7-6-4-6 4 1-7-5-5 7-1Z" fill="${red}"/>
    <path d="M24 55h16" stroke="${ink}" stroke-width="2"/>
  `,
  "practice-3": `
    <path d="M25 3h14v7H25ZM47 13l5-5 5 5-5 5" fill="${red}" stroke="${ink}" stroke-width="2.5"/>
    <circle cx="32" cy="35" r="25" fill="${gold}" stroke="${ink}" stroke-width="2.5"/>
    <circle cx="32" cy="35" r="19" fill="${cream}" stroke="${ink}" stroke-width="1.5"/>
    <path d="M32 19v4M48 35h-4M20 35h-4M32 51v-4M32 35l8-9" stroke="${ink}" stroke-width="2" stroke-linecap="round"/>
    <path d="M26 29h10l-6 7h4c5 0 5 9 0 9h-8" fill="none" stroke="${red}" stroke-width="3.5" stroke-linejoin="round"/>
    <path d="M4 18h7M1 26h8" stroke="${ink}" stroke-width="2" stroke-linecap="round"/>
  `,
};

export function achievementArt(id: string, size = 64): string {
  return `<svg class="achievement-art" viewBox="0 0 64 64" width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">${drawings[id] ?? drawings["first-hit"]}</svg>`;
}
